import k from './constants/k'

import menu from './scenes/menu'
import bookMenu from './scenes/bookMenu'
import room from './scenes/room'
import garden from './scenes/garden'
import forest from './scenes/forest'
import lake from './scenes/lake'
import completed from './scenes/completed'

k.loadRoot('./')

k.setCursor('none')

// sounds
k.loadSound('meow', 'sounds/meow.ogg')
k.loadSound('pop', 'sounds/pop.ogg')
k.loadSound('sparkle', 'sounds/sparkle.ogg')
k.loadSound('explode', 'sounds/explosion.wav')

k.loadSound('music', 'sounds/music.wav')
k.play('music', {
  volume: 0.4,
  loop: true,
  speed: 0.8
})

// scenes
k.scene('menu', () => menu())
k.scene('bookMenu', () => bookMenu())
k.scene('room', () => room())
k.scene('garden', () => garden())
k.scene('forest', () => forest())
k.scene('lake', () => lake())
k.scene('completed', () => completed())

k.go('menu')
